import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Routers } from "./root";
import { Layout, Footer, ResetPassword } from "fragments";
import { useModal } from "./utils";

const App = () => {
  const [currentToken, setCurrentToken] = useState({
    register: "",
    resetToken: "",
  });
  const location = useLocation();
  const { openModal } = useModal();
  const query = new URLSearchParams(location.search);
  const resetTokenQuery = query.get("resetToken");
  const register = query.get("token");
  const navigate = useNavigate();

  const checkFooterToShow =
    location?.pathname !== "/create-fundraiser" &&
    location?.pathname !== "/in-celebration" &&
    location?.pathname !== "/in-memory-of" &&
    location?.pathname !== "/favor-items" &&
    !location?.pathname.startsWith("/connect-bank-account");
  const contentColor = "#F4F4F4";

  useEffect(() => {
    if (currentToken?.register || currentToken?.resetToken) {
      navigate("/");
      localStorage.clear();
      openModal(<ResetPassword currentToken={currentToken} />);
    }
  }, [currentToken]);

  useEffect(() => {
    if (resetTokenQuery || register) {
      if (resetTokenQuery) {
        setCurrentToken({
          register: "",
          resetToken: resetTokenQuery,
        });
      } else {
        setCurrentToken({
          register: register,
          resetToken: "",
        });
      }
    }
  }, [resetTokenQuery, register]);

  return (
    <div>
      <div className="app-box" style={{ background: contentColor }}>
        <Layout />
        <Routers />

        {checkFooterToShow && <Footer />}
      </div>
      <ToastContainer position="bottom-right" />
    </div>
  );
};

export default App;
